export default "assets/frame-3.3132a7fe85ffc811.png"